import React from "react";
import {Link} from "react-router-dom";

class Promotion extends React.Component {
  constructor() {
    super();
    this.state = {
      showingAlert: false,
      showingHowUse1: true,
      showingHowUse2: false,
      showingHowUse3: false,
      showingHowUse4: false
    };
  }

  handleClickShowAlert() {
    this.setState({
      showingAlert: true
    });

    setTimeout(() => {
      this.setState({
        showingAlert: false
      });
    }, 2000);
  }

  showVideo(videoId) {
    this.setState({ "showingHowUse1": false });
    this.setState({ "showingHowUse2": false });
    this.setState({ "showingHowUse3": false });
    this.setState({ "showingHowUse4": false });

    const field = "showingHowUse" + videoId;
    this.setState({ [field]: true });
  }

  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (
      <section className="section howvideo-section" style={{background: "#fff", padding: "100px 0"}}>

        <div className="container">
        <div className="row">

          <div className="col-lg-6">

            <div className="HowItUse">

              <div id="video1" className="HowItUseContents" style={{ display: this.state.showingHowUse1 ? "block": "none" }}>
                <img src="/images/howtouse-1.jpg" alt="How To Troubleshoot The MightyWifi" />
              </div>

              <div id="video2" className="HowItUseContents" style={{ display: this.state.showingHowUse2 ? "block": "none" }}>
                <img src="/images/howtouse-2.jpg" alt="How To Troubleshoot The MightyWifi" />
              </div>

              <div id="video3" className="HowItUseContents" style={{ display: this.state.showingHowUse3 ? "block": "none" }}>
                <img src="/images/howtouse-3.jpg" alt="How To Troubleshoot The MightyWifi" />
              </div>

              <div id="video4" className="HowItUseContents" style={{ display: this.state.showingHowUse4 ? "block": "none" }}>
                <img src="/images/howtouse-4.jpg" alt="How To Troubleshoot The MightyWifi" />
              </div>

            </div>
          </div>

          <div className="col-lg-6" style={PaddingStyle}>
            <div className="mt-3 features_desc">
              <h1 className="Title">How to use</h1>

              {/* <div className="col-lg-12 no-padding">
                <ol className="HowItVideoList">
                  <li><a className="showBtn" target="1">How to Use The MightyWifi US & Global Hotspot and Troubleshoot.</a></li>
                  <li><a className="showBtn" target="2">How to Recharge Data packages and use our APP.</a></li>
                  <li><a className="showBtn" target="3">Unboxing New Device and Open and Return rental packages.</a></li>
                  <li><a className="showBtn" target="4">How to connect Mighty Powerbank accessories (sold separately)</a></li>
                </ol>
              </div> */}

              <div className="col-lg-12 no-padding">

                <div id="video1" className="Step1" style={{ display: this.state.showingHowUse1 ? "block": "none" }}>
                  <div className="howtouse-subtitle"><strong>STEP 1.</strong> Unboxing the MightyWifi Device</div>
                  <div className="howtouse-text">
                  Please find your device imei# on the back of the device. you would need the device IMEI# to assign active data package.<br/><br/>
                  Without an active data package, the device will not work.
                  </div>
                  <div className="howtouse-btn">
                  <a className="showBtn" onClick={ () => this.showVideo(2) }><span className="mr-1">NEXT</span> <span className="click-notice howtouse-btn"><img src="/images/click2.svg"/></span></a>
                  </div>
                </div>

                <div id="video2" className="Step2" style={{ display: this.state.showingHowUse2 ? "block": "none" }}>
                  <div className="howtouse-subtitle"><strong>STEP 2.</strong> Powering On</div>
                  <div className="howtouse-text">
                  Once data package has been assigned using activation or recharging the data, please press power button for 3 seconds to power it on.<br/><br/>
                  It may take few minutes to find the device and bind the active data you have purchased (make sure you have purchased right data package for the country you are traveling in)
                  </div>
                  <div className="howtouse-btn">
                  <a className="showBtn" onClick={ () => this.showVideo(3) }><span className="mr-1">NEXT</span> <span className="click-notice howtouse-btn"><img src="/images/click2.svg"/></span></a>
                  </div>
                </div>

                <div id="video3" className="Step3" style={{ display: this.state.showingHowUse3 ? "block": "none" }}>
                  <div className="howtouse-subtitle"><strong>STEP 3.</strong> Find Wifi name and password</div>
                  <div className="howtouse-text">
                  Once the network search is done, you will find SSID (Your WIFI name) and Key (Your Password) on your screen. When network search stops in 49%, please relocate to better reception area. When network search stops in 99%, you do not have an active data in that region. Please check your data for usage or expiration dates.
                  <br/><br/>Select Wifi Name starting Mighty_###### and when prompt to enter password, type Key (########)
                  </div>
                  <div className="howtouse-btn">
                  <a className="showBtn" onClick={ () => this.showVideo(4) }><span className="mr-1">NEXT</span> <span className="click-notice howtouse-btn"><img src="/images/click2.svg"/></span></a>
                  </div>
                </div>

                <div id="video3" className="Step4" style={{ display: this.state.showingHowUse4 ? "block": "none" }}>
                  <div className="howtouse-subtitle"><strong>STEP 4.</strong> Powering Off</div>
                  <div className="howtouse-text">
                  Our device is built in with 40 second sleep mode. The screen goes dark but the device is still on saving the battery life. Please unlock the device by pressing green power button once then white menu button to unlock. Once the device is unlocked, press power button for 3 seconds to turn it off.
                  </div>
                  <div className="howtouse-btn">
                  <a className="showBtn" onClick={ () => this.showVideo(1) }><span className="mr-1">NEXT</span> <span className="click-notice howtouse-btn"><img src="/images/click2.svg"/></span></a>
                  </div>
                </div>

                {/* <ol className="HowItVideoList">
                  <li><a className="showBtn" onClick={ () => this.showVideo(1) }><span className="click-notice"><img src="/images/click.svg"/></span> How to Use The MightyWifi US & Global Hotspot and Troubleshoot.</a></li>
                  <li><a className="showBtn" onClick={ () => this.showVideo(2) }><span className="click-notice"><img src="/images/click.svg"/></span> How to Recharge Data packages and use our APP.</a></li>
                  <li><a className="showBtn" onClick={ () => this.showVideo(3) }><span className="click-notice"><img src="/images/click.svg"/></span> Unboxing New Device and Open and Return rental packages.</a></li>
                  <li><a className="showBtn" onClick={ () => this.showVideo(4) }><span className="click-notice"><img src="/images/click.svg"/></span> How to connect Mighty Powerbank accessories (sold separately)</a></li>
                </ol> */}
              </div>

              <div style={clearStyle} />
            </div>
          </div>
        </div>
        </div>

      </section>
    );
  }
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/layout/HowItUse.js